import React from 'react';

import {Message} from '@pb/kit-component-message';

type NoteBannerProps = {
    message: string,
};

export const NoteBanner: React.FC<NoteBannerProps> = ({message}) => {
    return (
        <Message color="warning">
            <strong style={{fontWeight: 700}}>Note: </strong>{message}
        </Message>
    );
};
